var _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsuranceAmico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Floor-2--inject-39",
    d: "M93.46,271.75c-86.45,49.91-86.45,130.84,0,180.75,86.45,49.91,226.62,49.91,313.07,0,86.45-49.91,86.45-130.84,0-180.75-86.45-49.91-226.62-49.91-313.07,0Z",
    style: {
      fill: "#f7efe6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-39",
    d: "M233.63,328.36L50.31,434.2c-1.62,.93-4.44,.82-6.3-.26l-12.05-6.96c-1.87-1.08-2.07-2.71-.45-3.64l183.31-105.84c1.62-.93,4.44-.82,6.3,.26l12.05,6.96c1.87,1.08,2.07,2.71,.45,3.64Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow-2--inject-39",
    cx: 357.2,
    cy: 406.24,
    rx: 72.4,
    ry: 41.8,
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow-3--inject-39",
    d: "M182.73,457.74l139.27-80.44c1.82-1.05,1.82-2.76,0-3.81l-70.74-40.8c-1.82-1.05-4.77-1.05-6.59,0l-139.27,80.44c-1.82,1.05-1.82,2.76,0,3.81l70.74,40.8c1.82,1.05,4.77,1.05,6.59,0Z",
    style: {
      fill: "#e5d4c3"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants-2--inject-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M396.9,377.48l15.96,9.22c-.21-5.7-.71-14.17,.08-19.88,4.82-34.89,18.41-46.4,24.88-63.38,6.81-17.88-1.5-23.64-12.28-20.42-9.62,2.87-23.53,17.1-27.91,43.14-2.91,17.32-2.4,36.14-.73,51.33Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.9,377.48l15.96,9.22c-.21-5.7-.71-14.17,.08-19.88,4.82-34.89,18.41-46.4,24.88-63.38,6.81-17.88-1.5-23.64-12.28-20.42-9.62,2.87-23.53,17.1-27.91,43.14-2.91,17.32-2.4,36.14-.73,51.33Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.36,382.37l1.6,.92c-5.71-40.68,8.2-75.96,21.93-90.53,.26-.28,.25-.72-.03-.99-.29-.26-.73-.25-.99,.03-13.72,14.58-27.62,50.1-22.51,90.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M408.38,384.11l8.98,5.19h0c4.78-14.06,9.68-19.7,15.77-28.94,5.55-8.42,12-13.63,15.43-19.55,3.04-5.24,5.32-11.82,.81-15.8-7.18-6.34-16.55,.37-23,7.62-5.57,6.27-16.77,22.95-18,51.49Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.38,384.11l8.98,5.19h0c4.78-14.06,9.68-19.7,15.77-28.94,5.55-8.42,12-13.63,15.43-19.55,3.04-5.24,5.32-11.82,.81-15.8-7.18-6.34-16.55,.37-23,7.62-5.57,6.27-16.77,22.95-18,51.49Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.06,386.24l1.31,.76c3.77-22.24,18.88-47.98,28.27-54.05,.33-.21,.43-.66,.21-.99-.21-.34-.65-.43-.99-.21-9.72,6.3-24.79,31.91-28.8,54.5Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard-2--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.59,27.01L44.27,124.07c-1.74,1-3.15,3.44-3.15,5.45V421.66c0,2.01,1.41,4.44,3.15,5.44l.64,.36c1.74,1,4.56,.99,6.3-.01l168.32-97.19c1.74-1,3.15-3.45,3.15-5.45V32.8c0-2.01-1.41-4.44-3.15-5.44l-.64-.36c-1.74-1-4.56-.99-6.3,.01Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.59,27.01L44.27,124.07c-1.74,1-3.15,3.44-3.15,5.45V421.66c0,2.01,1.41,4.44,3.15,5.44l.64,.36c1.74,1,4.56,.99,6.3-.01l168.32-97.19c1.74-1,3.15-3.45,3.15-5.45V32.8c0-2.01-1.41-4.44-3.15-5.44l-.64-.36c-1.74-1-4.56-.99-6.3,.01Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.69,325.04c0,2.77-1.94,4.53-4.35,5.91L52.42,426.74c-2.39,1.38-4.35,.27-4.35-2.51V134.86h0c0-3.09,1.65-5.95,4.33-7.5L218.33,31.53c1.93-1.12,4.35,.28,4.35,2.51h0V325.04Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.69,325.04c0,2.77-1.94,4.53-4.35,5.91L52.42,426.74c-2.39,1.38-4.35,.27-4.35-2.51V134.86h0c0-3.09,1.65-5.95,4.33-7.5L218.33,31.53c1.93-1.12,4.35,.28,4.35,2.51h0V325.04Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.69,32.8v1.24c0-2.23-2.42-3.62-4.36-2.51L52.4,127.36c-1.35,.76-2.42,1.87-3.16,3.16-.02,.04-.04,.06-.05,.1l-7.18-4.15c.58-1.01,1.37-1.89,2.27-2.4L212.59,27.01c1.74-1.01,4.57-1.01,6.3-.01l.64,.37c1.74,.99,3.16,3.43,3.16,5.44Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.69,32.8v1.24c0-2.23-2.42-3.62-4.36-2.51L52.4,127.36c-1.35,.76-2.42,1.87-3.16,3.16-.02,.04-.04,.06-.05,.1l-7.18-4.15c.58-1.01,1.37-1.89,2.27-2.4L212.59,27.01c1.74-1.01,4.57-1.01,6.3-.01l.64,.37c1.74,.99,3.16,3.43,3.16,5.44Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow-4--inject-39",
    d: "M218.58,312.29c0,2.85-2,4.67-4.48,6.09L57.28,408.92c-2.47,1.43-4.48,.27-4.48-2.59V150.91h0c0-3.19,1.7-6.13,4.46-7.73L214.1,52.6c1.99-1.15,4.48,.29,4.48,2.59V312.29Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Form--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Paper--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.82,146.58L213.06,56.37c.74-.43,1.94-.43,2.68,0l1.51,.87c.74,.43,1.34,1.46,1.34,2.32V316.24c0,.85-.6,1.89-1.34,2.32L61,408.76c-.74,.43-1.94,.43-2.67,0l-1.51-.87c-.74-.43-1.34-1.46-1.34-2.32V148.89c0-.85,.6-1.89,1.34-2.32Z",
    style: {
      fill: "#faf5f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.68,408.91c-.15,.06-.32,.1-.49,.13-.08,.01-.18,.02-.26,.03-.27,.02-.55,.01-.81-.03-.18-.03-.34-.07-.49-.13-.1-.04-.21-.09-.3-.14l-1.5-.86c-.74-.43-1.34-1.46-1.34-2.32V148.9c0-.43,.14-.91,.39-1.32l4.18,2.41c-.24,.42-.39,.9-.39,1.32V407.99c0,.73,.43,1.09,1.02,.92Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M217.25,57.24l-1.51-.87c-.74-.43-1.94-.43-2.67,0L56.82,146.58c-.74,.43-1.34,1.46-1.34,2.32v34.63l4.18,2.43L218.58,94.2V59.55c0-.85-.6-1.89-1.34-2.32Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.25,57.24l-1.51-.87c-.74-.43-1.94-.43-2.67,0L56.82,146.58c-.74,.43-1.34,1.46-1.34,2.32v34.63l4.18,2.43L218.58,94.2V59.55c0-.85-.6-1.89-1.34-2.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M218.53,59.15c-.16-.55-.68-.72-1.29-.37L61,148.99c-.37,.22-.71,.58-.95,1l-4.18-2.41c.24-.42,.58-.79,.95-1L213.07,56.37c.73-.43,1.94-.43,2.67,0l1.51,.87c.63,.37,1.15,1.16,1.29,1.91Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.53,59.15c-.16-.55-.68-.72-1.29-.37L61,148.99c-.37,.22-.71,.58-.95,1l-4.18-2.41c.24-.42,.58-.79,.95-1L213.07,56.37c.73-.43,1.94-.43,2.67,0l1.51,.87c.63,.37,1.15,1.16,1.29,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.48,148.9v34.64l4.18,2.41v-34.65c0-.42,.15-.9,.39-1.32l-4.18-2.41c-.25,.41-.39,.89-.39,1.32Z",
    style: {
      fill: "#e9a026"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clip_Board--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.35,196.42l95.71-55.41c.42-.24,.76-.05,.76,.44v.99c0,.49-.34,1.08-.76,1.32l-95.72,55.41c-.42,.24-.76,.05-.76-.44v-.99c0-.49,.34-1.08,.76-1.32Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.24,237.51v1.4c0,.76,.53,1.06,1.19,.69l63.08-36.37c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-63.08,36.38c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,246.32v1.4c0,.76,.53,1.06,1.19,.69l108.34-62.52c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-108.34,62.52c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,254.7v1.4c0,.76,.53,1.06,1.19,.69l108.34-62.52c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-108.34,62.52c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.65,272.21c-.11,0-.21-.03-.31-.08-.19-.11-.31-.31-.31-.53v-20.23c0-.22,.12-.42,.31-.53l17.4-10.04c.19-.11,.42-.11,.61,0,.19,.11,.31,.31,.31,.53v20.23c0,.22-.12,.42-.31,.53l-17.39,10.04c-.09,.06-.2,.08-.31,.08Zm.61-20.49v18.82l16.17-9.34v-18.82l-16.17,9.34Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.13 262.75 75.08 258.86 76.43 255.99 78.74 258.21 88.71 237.1 90.45 238.78 79.13 262.75",
    style: {
      fill: "#e9a026"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.24,269.18v1.4c0,.76,.53,1.06,1.19,.69l63.08-36.37c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-63.08,36.38c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,277.99v1.4c0,.76,.53,1.06,1.19,.69l108.34-62.52c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-108.34,62.52c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,286.38v1.4c0,.76,.53,1.06,1.19,.69l108.34-62.52c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-108.34,62.52c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.65,303.88c-.11,0-.21-.03-.31-.08-.19-.11-.31-.31-.31-.53v-20.23c0-.22,.12-.42,.31-.53l17.4-10.04c.19-.11,.42-.11,.61,0,.19,.11,.31,.31,.31,.53v20.23c0,.22-.12,.42-.31,.53l-17.39,10.04c-.09,.06-.2,.08-.31,.08Zm.61-20.49v18.82l16.17-9.34v-18.82l-16.17,9.34Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.13 294.42 75.08 290.53 76.43 287.66 78.74 289.88 88.71 268.78 90.45 270.45 79.13 294.42",
    style: {
      fill: "#e9a026"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.24,300.86v1.4c0,.76,.53,1.06,1.19,.69l63.08-36.37c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-63.08,36.38c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,309.66v1.4c0,.76,.53,1.06,1.19,.69l108.34-62.52c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-108.34,62.52c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,318.05v1.4c0,.76,.53,1.06,1.19,.69l108.34-62.52c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-108.34,62.52c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.65,335.55c-.11,0-.21-.03-.31-.08-.19-.11-.31-.31-.31-.53v-20.23c0-.22,.12-.42,.31-.53l17.4-10.04c.19-.11,.42-.11,.61,0,.19,.11,.31,.31,.31,.53v20.23c0,.22-.12,.42-.31,.53l-17.39,10.04c-.09,.05-.2,.08-.31,.08Zm.61-20.49v18.82l16.17-9.34v-18.82l-16.17,9.34Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.13 326.1 75.08 322.2 76.43 319.34 78.74 321.55 88.71 300.45 90.45 302.13 79.13 326.1",
    style: {
      fill: "#e9a026"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.24,332.53v1.4c0,.76,.53,1.06,1.19,.69l63.08-36.37c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-63.08,36.38c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,341.34v1.4c0,.76,.53,1.06,1.19,.69l108.34-62.52c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-108.34,62.52c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,349.72v1.4c0,.76,.53,1.06,1.19,.69l108.34-62.52c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-108.34,62.52c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.65,367.23c-.11,0-.21-.03-.31-.08-.19-.11-.31-.31-.31-.53v-20.23c0-.22,.12-.42,.31-.53l17.4-10.04c.19-.11,.42-.11,.61,0,.19,.11,.31,.31,.31,.53v20.23c0,.22-.12,.42-.31,.53l-17.39,10.04c-.09,.06-.2,.08-.31,.08Zm.61-20.49v18.82l16.17-9.34v-18.82l-16.17,9.34Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.13 357.77 75.08 353.88 76.43 351.01 78.74 353.23 88.71 332.12 90.45 333.8 79.13 357.77",
    style: {
      fill: "#e9a026"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.04,221.67v1.4c0,.76,.53,1.06,1.19,.69l133.54-77.12c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69L71.22,219.62c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.04,230.57v1.4c0,.76,.53,1.06,1.19,.69l133.54-77.12c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69L71.22,228.51c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.04,239.47v1.4c0,.76,.53,1.06,1.19,.69l133.54-77.12c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69L71.22,237.41c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.04,379.05v1.4c0,.76,.53,1.06,1.19,.69l133.54-77.12c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-133.55,77.12c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.04,387.94v1.4c0,.76,.53,1.06,1.19,.69l133.54-77.12c.66-.38,1.19-1.3,1.19-2.06v-1.4c0-.76-.53-1.06-1.19-.69l-133.55,77.12c-.66,.38-1.19,1.3-1.19,2.06Z",
    style: {
      fill: "#e5d4c3"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.46,160.9l54.71-31.61c.79-.46,1.43-.09,1.43,.82v.42c0,.91-.64,2.02-1.43,2.47l-54.71,31.61c-.79,.46-1.43,.09-1.43-.82v-.42c0-.91,.64-2.02,1.43-2.47Z",
    style: {
      fill: "#f7efe6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.46,168.38l32.55-18.79c.79-.46,1.43-.09,1.43,.82v.42c0,.91-.64,2.02-1.43,2.47l-32.55,18.79c-.79,.46-1.43,.09-1.43-.82v-.42c0-.91,.64-2.02,1.43-2.47Z",
    style: {
      fill: "#f7efe6"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M180.91,97.23l24.33-14.06c.39-.23,.71-.04,.71,.41v.93c0,.45-.32,1.01-.71,1.23l-24.33,14.06c-.39,.23-.71,.04-.71-.41v-.93c0-.45,.32-1.01,.71-1.23Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.91,108.45l24.33-14.06c.39-.23,.71-.04,.71,.41v.93c0,.45-.32,1.01-.71,1.23l-24.33,14.06c-.39,.23-.71,.04-.71-.41v-.93c0-.45,.32-1.01,.71-1.23Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.93,99.91l19.31-11.15c.39-.23,.71-.04,.71,.41v.93c0,.45-.32,1.01-.71,1.23l-19.31,11.15c-.39,.23-.71,.04-.71-.41v-.93c0-.45,.32-1.01,.71-1.23Z",
    style: {
      fill: "#e9a026"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M93.21,191.98c-.12,.07-.22,.06-.3-.02-.09-.08-.13-.21-.13-.4v-16c0-.18,.04-.36,.13-.54,.09-.18,.19-.31,.3-.37l1.3-.75c.12-.07,.22-.06,.31,.02,.09,.08,.13,.21,.13,.4v16c0,.18-.04,.36-.13,.55-.09,.18-.19,.31-.31,.37l-1.3,.75Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.76,185.31c-.18,.11-.32,.11-.42,.02-.1-.09-.17-.17-.21-.23l-4.5-7.7v10.2c0,.18-.04,.36-.13,.55-.08,.18-.19,.31-.3,.37l-1.3,.75c-.12,.07-.22,.06-.31-.02-.08-.08-.13-.21-.13-.4v-16c0-.18,.04-.36,.13-.54,.09-.18,.19-.31,.31-.37l1.13-.65c.18-.11,.32-.11,.42-.02,.1,.09,.17,.17,.21,.23l4.5,7.7v-10.2c0-.18,.04-.36,.13-.54,.09-.18,.19-.31,.3-.37l1.3-.75c.12-.07,.22-.06,.31,.02,.09,.08,.13,.21,.13,.4v16c0,.18-.04,.36-.13,.55-.09,.18-.19,.31-.31,.37l-1.13,.65Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.69,163.15c.72-.41,1.35-.63,1.9-.65,.55-.02,1,.09,1.37,.33,.37,.24,.64,.57,.83,.99,.19,.43,.29,.88,.31,1.34,.01,.19-.03,.38-.12,.55-.09,.18-.2,.3-.31,.37l-1.13,.65c-.18,.11-.32,.13-.41,.08-.09-.05-.17-.15-.25-.29-.16-.32-.41-.54-.73-.65-.33-.12-.81,.01-1.45,.38-.28,.16-.54,.36-.8,.6-.25,.24-.47,.49-.66,.78-.19,.28-.34,.58-.44,.89-.11,.31-.16,.62-.16,.94,0,.38,.05,.66,.15,.84,.1,.18,.27,.29,.52,.32,.24,.03,.56,.01,.96-.07,.4-.08,.89-.19,1.48-.33,.64-.16,1.2-.23,1.66-.21,.47,.02,.85,.15,1.14,.38s.52,.57,.66,1.02c.14,.44,.22,1.01,.22,1.68,0,.74-.11,1.49-.32,2.25-.22,.76-.52,1.48-.92,2.16-.4,.68-.89,1.33-1.46,1.92-.58,.6-1.23,1.11-1.95,1.52-.6,.35-1.17,.57-1.72,.66-.55,.09-1.03,.05-1.46-.13-.42-.18-.76-.49-1.02-.93-.26-.44-.4-1.02-.43-1.73-.01-.19,.03-.38,.12-.55,.09-.18,.2-.3,.32-.37l1.12-.65c.18-.11,.32-.14,.42-.09,.1,.04,.18,.14,.24,.31,.07,.17,.17,.33,.27,.49,.11,.15,.25,.26,.43,.32,.18,.06,.41,.06,.68,.01,.27-.05,.61-.19,1.02-.43,.32-.19,.63-.4,.93-.65,.3-.25,.56-.52,.79-.83,.23-.3,.41-.62,.55-.96,.14-.34,.21-.69,.21-1.07s-.08-.62-.22-.76c-.15-.14-.38-.21-.68-.2-.31,.01-.68,.07-1.13,.18-.45,.11-.97,.22-1.56,.33-.54,.11-1,.15-1.41,.11-.4-.04-.73-.18-1-.43-.26-.24-.46-.6-.59-1.06-.13-.46-.19-1.06-.19-1.81s.11-1.49,.32-2.24c.22-.75,.51-1.46,.88-2.12,.38-.66,.82-1.27,1.34-1.83,.52-.56,1.08-1.01,1.68-1.35Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.95,154.58c.12-.07,.22-.06,.31,.02,.08,.08,.13,.21,.13,.4v10.15c0,1.02-.1,2-.29,2.94-.19,.94-.48,1.81-.87,2.63-.39,.82-.87,1.55-1.45,2.21-.58,.66-1.25,1.21-2.01,1.64-.77,.45-1.45,.67-2.02,.68-.57,0-1.05-.17-1.44-.54-.38-.37-.67-.92-.86-1.63-.19-.72-.28-1.59-.28-2.61v-10.15c0-.18,.04-.36,.13-.54,.08-.18,.19-.31,.31-.37l1.3-.75c.12-.07,.22-.06,.31,.02,.08,.08,.13,.21,.13,.4v10.03c0,.68,.06,1.22,.18,1.63,.12,.41,.28,.71,.5,.89,.22,.18,.47,.26,.77,.22,.3-.03,.63-.15,.98-.36,.35-.2,.68-.46,.99-.78,.31-.32,.57-.69,.78-1.12,.21-.43,.38-.92,.51-1.47,.12-.55,.19-1.16,.19-1.84v-10.03c0-.18,.04-.36,.13-.54,.08-.18,.19-.31,.3-.37l1.29-.74Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.4,150.28c1.34-.77,2.36-.88,3.06-.33,.7,.56,1.05,1.68,1.05,3.38,0,1.21-.18,2.34-.54,3.39-.36,1.06-.89,1.99-1.58,2.81l2.22,4.84c.03,.08,.05,.16,.05,.24,0,.15-.04,.3-.1,.44-.07,.15-.15,.25-.25,.31l-1.37,.79c-.21,.12-.37,.14-.48,.04-.1-.1-.17-.2-.22-.31l-2.11-4.55-2.14,1.23v5.77c0,.18-.04,.36-.13,.55-.08,.18-.19,.31-.31,.37l-1.3,.75c-.12,.07-.22,.06-.31-.02-.08-.08-.13-.21-.13-.4v-16c0-.18,.04-.36,.13-.54,.09-.18,.19-.31,.31-.37l4.15-2.4Zm-2.41,9.19l2.33-1.35c.61-.35,1.1-.8,1.46-1.34,.37-.54,.55-1.27,.55-2.2s-.18-1.44-.55-1.54c-.36-.1-.85,.02-1.46,.37l-2.33,1.35v4.71Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.88,143.65c.17-.1,.3-.1,.39-.01,.09,.09,.16,.26,.23,.5l3.94,13.38s.02,.1,.02,.16c0,.18-.04,.36-.13,.55-.09,.18-.19,.31-.31,.37l-1.16,.67c-.21,.12-.36,.14-.45,.05-.09-.09-.14-.19-.18-.31l-.69-2.35-5.08,2.93-.69,3.15c-.03,.15-.09,.32-.18,.51-.09,.19-.24,.35-.45,.47l-1.16,.67c-.12,.07-.22,.06-.31-.02-.09-.08-.13-.21-.13-.4,0-.07,0-.13,.02-.18l3.94-17.93c.06-.32,.14-.57,.22-.76,.09-.19,.22-.33,.39-.43l1.77-1.02Zm.88,10.36l-1.77-6.04-1.77,8.08,3.54-2.04Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.22,153.29c-.18,.11-.32,.11-.42,.02-.1-.09-.17-.17-.21-.23l-4.5-7.7v10.2c0,.18-.04,.36-.13,.55-.08,.18-.19,.31-.3,.37l-1.3,.75c-.12,.07-.22,.06-.31-.02-.08-.08-.13-.21-.13-.4v-16c0-.18,.04-.36,.13-.54,.09-.18,.19-.31,.31-.37l1.13-.65c.18-.11,.32-.11,.42-.02,.1,.09,.17,.17,.21,.23l4.5,7.7v-10.2c0-.18,.04-.36,.13-.54,.09-.18,.19-.31,.31-.37l1.3-.75c.12-.07,.22-.06,.31,.02s.13,.21,.13,.4v16c0,.18-.04,.36-.13,.55s-.19,.31-.31,.37l-1.13,.65Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.2,141.45c.02-.23,.08-.42,.17-.58,.09-.16,.19-.27,.3-.33l1.3-.75c.12-.07,.22-.07,.31,0,.09,.07,.13,.21,.12,.41-.03,.7-.14,1.44-.33,2.22-.19,.79-.48,1.56-.86,2.33-.39,.77-.87,1.5-1.46,2.18-.59,.69-1.3,1.27-2.14,1.76-.74,.43-1.39,.63-1.96,.63-.57-.01-1.05-.2-1.45-.58-.4-.37-.71-.92-.93-1.63-.22-.72-.35-1.56-.39-2.52-.02-.61-.03-1.3-.03-2.06s.01-1.46,.03-2.1c.04-1.02,.17-2.01,.39-2.98,.22-.97,.53-1.87,.93-2.7,.4-.83,.88-1.58,1.45-2.25,.57-.67,1.22-1.21,1.96-1.64,.84-.48,1.55-.72,2.14-.71,.59,0,1.08,.17,1.46,.49,.39,.32,.67,.77,.86,1.35,.19,.58,.3,1.19,.33,1.83,.01,.19-.03,.38-.12,.55-.09,.18-.2,.3-.31,.37l-1.3,.75c-.11,.06-.21,.07-.31,.02-.1-.05-.15-.18-.18-.38-.03-.31-.11-.59-.22-.84-.12-.25-.28-.43-.48-.56-.2-.13-.46-.18-.77-.16-.31,.02-.68,.15-1.09,.4-.42,.24-.78,.55-1.09,.93-.31,.38-.57,.79-.78,1.24s-.37,.94-.48,1.47c-.11,.53-.18,1.05-.2,1.58-.02,.64-.03,1.34-.03,2.1s.01,1.45,.03,2.06c.02,.52,.09,.97,.2,1.36,.11,.39,.27,.69,.48,.9,.21,.21,.47,.32,.78,.34,.31,.02,.68-.09,1.09-.33,.42-.24,.78-.53,1.09-.87,.31-.34,.57-.69,.78-1.06,.21-.37,.37-.74,.49-1.13,.12-.38,.19-.75,.22-1.1Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.78,137.17c.12-.07,.22-.06,.3,.02,.09,.08,.13,.21,.13,.4v1.76c0,.18-.04,.36-.13,.55-.08,.18-.19,.31-.3,.37l-7.06,4.08c-.12,.07-.22,.06-.31-.02-.09-.08-.13-.21-.13-.4v-16c0-.18,.04-.36,.13-.54,.09-.18,.19-.31,.31-.37l6.93-4c.12-.07,.22-.06,.31,.02,.08,.08,.13,.21,.13,.4v1.76c0,.18-.04,.36-.13,.55-.09,.18-.19,.31-.31,.37l-5.2,3v3.94l4.84-2.8c.12-.07,.22-.06,.31,.02,.09,.08,.13,.21,.13,.4v1.76c0,.18-.04,.36-.13,.54-.08,.18-.19,.31-.31,.38l-4.84,2.8v4.11l5.32-3.07Z",
    style: {
      fill: "#4a3729"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clip--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow-5--inject-39",
    style: {
      opacity: 0.25
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.44,67.66v13.43c0,3.4-2.32,7.42-5.27,9.12l-26,15.01c-1.29,.74-2.02,2.22-2.79,3.78-.57,1.15-1.16,2.32-2.01,3.28-2.02,2.29-6.42,4.68-9.53,5.67-1.05,.34-2.09,.58-3.12,.72-.39,.07-.83,.12-1.28,.17-2.84,.38-6.37,.86-8.44,2.06l-30.43,17.56c-.92,.53-1.82,.8-2.65,.8-.64,0-1.24-.15-1.78-.46-1.24-.72-1.93-2.15-1.93-4v-13.43c0-3.4,2.31-7.42,5.27-9.12l10.22-5.9s.09-.04,.14-.05c.49-.22,1.07-.02,1.35,.46,.27,.47,.14,1.08-.28,1.39-.03,.04-.08,.08-.12,.1l-10.22,5.9c-2.26,1.31-4.18,4.62-4.18,7.23v13.43c0,1.04,.31,1.8,.84,2.11,.53,.32,1.35,.19,2.25-.33l30.43-17.57c2.44-1.41,6.22-1.92,9.24-2.32,.45-.05,.87-.12,1.27-.17,.89-.13,1.83-.34,2.77-.64,2.76-.87,6.86-3.11,8.55-5.03,.67-.74,1.16-1.76,1.69-2.81,.88-1.79,1.8-3.63,3.65-4.7l26-15.01c2.26-1.31,4.18-4.62,4.18-7.23v-13.43c0-1.03-.31-1.8-.84-2.1-.53-.32-1.36-.19-2.25,.33l-8.86,5.11c-.29-.67-.68-1.31-1.11-1.88l8.88-5.13c1.6-.94,3.18-1.05,4.43-.34,1.24,.72,1.93,2.15,1.93,4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clip-2--inject-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M163.47,67.91h0c.7-.41,1.67-.36,2.74,.26,2.13,1.23,3.86,4.23,3.86,6.69,0,1.24-.44,2.11-1.15,2.51h0l-61.69,35.62-5.46-9.47,61.69-35.62Z",
    style: {
      fill: "#5c4a3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.53,108.29l64.43-37.2c-.7-1.22-1.67-2.29-2.74-2.91-.13-.07-.25-.11-.37-.17l-63.43,36.62,2.11,3.66Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.53,103.8c-2.13-1.23-3.86-.23-3.86,2.23s1.73,5.46,3.86,6.69c2.13,1.23,3.86,.23,3.86-2.23,0-2.46-1.73-5.46-3.86-6.69Z",
    style: {
      fill: "#3d200f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.54,68.62v13.43c0,3.4-2.32,7.42-5.27,9.12l-26,15.01c-1.29,.74-2.02,2.22-2.79,3.78-.57,1.15-1.16,2.32-2.01,3.28-2.02,2.29-6.42,4.68-9.53,5.67-1.05,.34-2.09,.58-3.12,.72-.39,.07-.83,.12-1.28,.17-2.84,.38-6.37,.86-8.44,2.06l-30.43,17.56c-.92,.53-1.82,.8-2.65,.8-.64,0-1.24-.15-1.78-.46-1.24-.72-1.93-2.15-1.93-4v-13.43c0-3.4,2.31-7.42,5.27-9.12l10.22-5.9s.09-.04,.14-.05c.49-.22,1.07-.02,1.35,.46,.27,.47,.14,1.08-.28,1.38-.03,.04-.08,.08-.12,.1l-10.22,5.9c-2.26,1.31-4.18,4.62-4.18,7.23v13.43c0,1.04,.31,1.8,.84,2.1,.53,.32,1.35,.19,2.25-.33l30.43-17.57c2.44-1.41,6.22-1.92,9.24-2.32,.45-.05,.87-.12,1.26-.17,.89-.13,1.83-.34,2.77-.64,2.76-.87,6.86-3.11,8.55-5.03,.67-.74,1.16-1.76,1.69-2.81,.88-1.79,1.8-3.63,3.65-4.7l26-15.01c2.26-1.31,4.18-4.62,4.18-7.23v-13.43c0-1.03-.31-1.8-.84-2.1-.53-.32-1.36-.19-2.25,.33l-8.86,5.11c-.29-.67-.68-1.31-1.11-1.88l8.88-5.13c1.6-.94,3.18-1.05,4.43-.34,1.24,.72,1.93,2.15,1.93,4Z",
    style: {
      fill: "#4a3729"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Banknotes--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money-2--inject-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "116.37 396.71 247.38 321.3 312.89 359 181.87 434.41 116.37 396.71",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.37 396.71 247.38 321.3 312.89 359 181.87 434.41 116.37 396.71",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.38,325.26l-124.12,71.44,58.61,33.74,124.12-71.44-58.61-33.74Zm-65.51,103.19l-55.16-31.75,120.67-69.46,55.16,31.75-120.67,69.46Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.2,392.25c-5.86-3.37-9.09-7.99-9.09-12.99,0-5.46,3.94-10.86,10.82-14.81,13.47-7.75,34.61-8.2,47.13-.99,5.86,3.37,9.09,7.99,9.09,12.99,0,5.46-3.94,10.86-10.82,14.81h0c-7.06,4.06-16.22,6.12-25.15,6.12-8.11,0-16.02-1.7-21.98-5.13Zm2.31-26.79c-6.5,3.74-10.23,8.77-10.23,13.8,0,4.57,3.02,8.82,8.51,11.98,12.19,7.02,32.81,6.57,45.96-.99h0c6.5-3.74,10.23-8.77,10.23-13.8,0-4.57-3.02-8.82-8.51-11.98-5.8-3.34-13.5-4.99-21.39-4.99-8.71,0-17.67,2.01-24.56,5.98Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.32,388.59c-4.5-2.59-6.97-5.9-6.97-9.33,0-3.9,3.17-7.97,8.7-11.15,6.15-3.54,14.54-5.57,23.03-5.57,7.68,0,14.73,1.63,19.86,4.58,4.5,2.59,6.97,5.9,6.97,9.33,0,3.9-3.17,7.97-8.7,11.15-6.15,3.54-14.54,5.57-23.02,5.57-7.68,0-14.74-1.63-19.86-4.58Z",
    style: {
      fill: "#e9a026"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M185.03,419.32c-1.74-1-4.58-.99-6.32,0l-3.74,2.15-35.92-20.54,4.33-2.49c.73-.42,1.14-.95,1.14-1.48,0-.53-.4-1.05-1.14-1.47l-4.32-2.49,39.44-22.83-.77,1.68c-.97,2.1-1.46,4.27-1.46,6.44,0,6.4,6.43,12.96,12.8,16.63,5.69,3.27,15.64,6.58,25.06,6.58,2.6,0,5.21-.17,7.77-.5l2.89-.37-36.01,20.85-3.74-2.16Z",
    style: {
      fill: "#e9a026",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.63,405.67c-1.5-.86-2.32-2.06-2.32-3.38,0-1.42,.99-2.81,2.72-3.8,3.22-1.86,8.29-1.96,11.3-.23,1.49,.86,2.32,2.06,2.32,3.38,0,1.42-.99,2.81-2.72,3.8-1.69,.97-3.88,1.46-6.01,1.46-1.95,0-3.85-.41-5.28-1.23Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M251.42,383.84c.95-2.08,1.51-5.62,1.51-7.85,0-5.32-4.2-10.44-12.5-15.22-6.64-3.82-16.83-6.39-25.36-6.39-2.61,0-5.23,.17-7.78,.49l-2.92,.38,36.01-20.66,3.74,2.16c1.71,.98,4.6,.98,6.31,0l3.74-2.16,35.86,20.36-4.33,2.5c-.73,.42-1.13,.94-1.13,1.47,0,.53,.4,1.06,1.13,1.48l4.33,2.49-39.36,22.6,.76-1.66Z",
    style: {
      fill: "#e9a026",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.08,358.4c-1.5-.86-2.32-2.06-2.32-3.38,0-1.42,.99-2.81,2.72-3.8,3.22-1.86,8.29-1.96,11.3-.23,1.5,.86,2.32,2.06,2.32,3.38,0,1.42-.99,2.81-2.72,3.8h0c-1.69,.97-3.88,1.46-6.01,1.46-1.95,0-3.85-.41-5.28-1.23Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "116.37 396.71 116.37 412.58 181.87 450.29 181.87 434.41 116.37 396.71",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "116.37 396.71 116.37 412.58 181.87 450.29 181.87 434.41 116.37 396.71",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "181.87 437.95 161.19 426.48 181.87 438.91 181.87 437.95"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "116.37 404.25 123.26 408.62 116.37 405.05 116.37 404.25"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "116.37 408.03 150.84 428.46 116.37 409.2 116.37 408.03"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.87 441.73 147.4 422.51 181.87 442.98 181.87 441.73"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "181.87 450.29 312.89 374.88 312.89 359 181.87 434.41 181.87 450.29",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.87 450.29 312.89 374.88 312.89 359 181.87 434.41 181.87 450.29"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.87 437.95 188.78 434.41 181.87 438.91 181.87 437.95"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.87 441.73 216.54 422.41 181.87 442.98 181.87 441.73"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "312.89 366.47 288.75 380.83 312.89 367.41 312.89 366.47"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "312.89 370.47 299.1 378.85 312.89 371.36 312.89 370.47"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "170.46 362.94 238.25 401.96 258.93 390.06 191.15 351.03 170.46 362.94",
    style: {
      fill: "#f7efe6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.93 390.06 258.93 407.33 238.25 419.24 238.25 401.96 258.93 390.06",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.25 419.24 237.04 418.54 238.25 417.84 238.25 419.24",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.46 362.94 170.46 365.57 172.75 364.25 170.46 362.94",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "237.04 418.53 237.04 402.66 238.25 401.96 238.25 417.83 237.04 418.53"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }, _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "237.04 402.66 171.54 364.95 172.75 364.25 238.25 401.96 237.04 402.66"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "172.69 361.65 240.49 400.67 242.2 399.68 174.42 360.67 172.69 361.65",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.18 353.32 254.97 392.34 256.69 391.35 188.9 352.33 187.18 353.32",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.49 400.67 240.49 417.95 242.2 416.96 242.2 399.68 240.49 400.67",
    style: {
      fill: "#3d200f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.97 392.34 254.97 409.61 256.7 408.62 256.69 391.35 254.97 392.34",
    style: {
      fill: "#3d200f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow-6--inject-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "175.22 430.59 306.24 355.18 247.38 321.3 116.37 396.71 175.22 430.59",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.37 406.07 175.22 439.95 175.22 430.58 116.37 396.71 116.37 406.07",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money-3--inject-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "105.28 376.33 236.3 300.92 301.8 338.62 170.79 414.03 105.28 376.33",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.28 376.33 236.3 300.92 301.8 338.62 170.79 414.03 105.28 376.33",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.3,304.89l-124.12,71.44,58.61,33.74,124.12-71.44-58.61-33.74Zm-65.51,103.19l-55.16-31.75,120.67-69.46,55.16,31.75-120.67,69.46Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.12,371.88c-5.86-3.37-9.09-7.99-9.09-12.99,0-5.46,3.94-10.86,10.82-14.81,13.47-7.75,34.61-8.2,47.13-.99,5.86,3.37,9.09,7.99,9.09,12.99,0,5.46-3.94,10.86-10.82,14.81h0c-7.06,4.06-16.22,6.12-25.15,6.12-8.11,0-16.02-1.7-21.98-5.13Zm2.31-26.79c-6.5,3.74-10.23,8.77-10.23,13.8,0,4.57,3.02,8.82,8.51,11.98,12.19,7.02,32.81,6.57,45.96-.99h0c6.5-3.74,10.23-8.77,10.23-13.8,0-4.57-3.02-8.82-8.51-11.98-5.8-3.34-13.5-4.99-21.39-4.99-8.71,0-17.67,2.01-24.56,5.98Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.24,368.21c-4.5-2.59-6.97-5.9-6.97-9.33,0-3.9,3.17-7.97,8.7-11.15,6.15-3.54,14.54-5.57,23.03-5.57,7.68,0,14.73,1.63,19.86,4.58,4.5,2.59,6.97,5.9,6.97,9.33,0,3.9-3.17,7.97-8.7,11.15-6.15,3.54-14.54,5.57-23.02,5.57-7.68,0-14.74-1.63-19.86-4.58Z",
    style: {
      fill: "#e9a026"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.95,398.94c-1.74-1-4.58-.99-6.32,0l-3.74,2.15-35.92-20.54,4.33-2.49c.73-.42,1.14-.95,1.14-1.48,0-.53-.4-1.05-1.14-1.47l-4.32-2.49,39.44-22.83-.77,1.68c-.97,2.1-1.46,4.27-1.46,6.44,0,6.4,6.43,12.96,12.8,16.63,5.69,3.27,15.64,6.58,25.06,6.58,2.6,0,5.21-.17,7.77-.5l2.89-.37-36.01,20.85-3.74-2.16Z",
    style: {
      fill: "#e9a026",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.55,385.29c-1.5-.86-2.32-2.06-2.32-3.38,0-1.42,.99-2.81,2.72-3.8,3.22-1.86,8.29-1.96,11.3-.23,1.49,.86,2.32,2.06,2.32,3.38,0,1.42-.99,2.81-2.72,3.8-1.69,.97-3.88,1.46-6.01,1.46-1.95,0-3.85-.41-5.28-1.23Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M240.34,363.46c.95-2.08,1.51-5.62,1.51-7.85,0-5.32-4.2-10.44-12.5-15.22-6.64-3.82-16.83-6.39-25.36-6.39-2.61,0-5.23,.17-7.78,.49l-2.92,.38,36.01-20.66,3.74,2.16c1.71,.98,4.6,.98,6.31,0l3.74-2.16,35.86,20.36-4.33,2.5c-.73,.42-1.13,.94-1.13,1.47,0,.53,.4,1.06,1.13,1.48l4.33,2.49-39.36,22.6,.76-1.66Z",
    style: {
      fill: "#e9a026",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239,338.03c-1.5-.86-2.32-2.06-2.32-3.38,0-1.42,.99-2.81,2.72-3.8,3.22-1.86,8.29-1.96,11.3-.23,1.5,.86,2.32,2.06,2.32,3.38,0,1.42-.99,2.81-2.72,3.8h0c-1.69,.97-3.88,1.46-6.01,1.46-1.95,0-3.85-.41-5.28-1.23Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "105.28 376.33 105.28 392.21 170.79 429.91 170.79 414.03 105.28 376.33",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "105.28 376.33 105.28 392.21 170.79 429.91 170.79 414.03 105.28 376.33",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "170.79 417.57 150.1 406.1 170.79 418.54 170.79 417.57"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "105.28 383.87 112.18 388.24 105.29 384.67 105.28 383.87"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "105.28 387.65 139.75 408.08 105.28 388.82 105.28 387.65"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "170.79 421.35 136.31 402.13 170.79 422.6 170.79 421.35"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "170.79 429.91 301.8 354.5 301.8 338.62 170.79 414.03 170.79 429.91",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "170.79 429.91 301.8 354.5 301.8 338.62 170.79 414.03 170.79 429.91"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "170.79 417.57 177.69 414.03 170.79 418.54 170.79 417.57"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "170.79 421.35 205.46 402.04 170.79 422.6 170.79 421.35"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "301.8 346.1 277.67 360.46 301.8 347.03 301.8 346.1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "301.8 350.09 288.01 358.47 301.8 350.98 301.8 350.09"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "159.38 342.56 227.16 381.58 247.85 369.68 180.06 330.65 159.38 342.56",
    style: {
      fill: "#f7efe6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.85 369.68 247.85 386.96 227.16 398.86 227.16 381.58 247.85 369.68",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.16 398.86 225.95 398.16 227.16 397.46 227.16 398.86",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.38 342.56 159.38 345.19 161.66 343.87 159.38 342.56",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "225.95 398.15 225.95 382.29 227.16 381.58 227.16 397.46 225.95 398.15"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }, _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "225.95 382.29 160.45 344.57 161.66 343.87 227.16 381.58 225.95 382.29"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "161.6 341.28 229.4 380.3 231.12 379.3 163.33 340.29 161.6 341.28",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.09 332.94 243.89 371.96 245.61 370.97 177.82 331.95 176.09 332.94",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.4 380.3 229.4 397.57 231.12 396.58 231.12 379.3 229.4 380.3",
    style: {
      fill: "#3d200f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.89 371.96 243.89 389.23 245.62 388.24 245.61 370.97 243.89 371.96",
    style: {
      fill: "#3d200f"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield-2--inject-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M259.85,187.12c.05-1.33-.27-2.16-.86-2.48,0-.01,.01-.01,.01-.01l-.08-.05c-.63-.28-4.81-2.77-5.41-3.09,0-.01,.01-.01,.01-.01l-.08-.05c-.63-.28-1.56-.01-2.68,.84-11.16,8.54-26.51,10.62-38.19,5.48-1.61-1.19-3.1-2.55-4.43-4.1-.07-.08-.13-.16-.2-.23h-.01c-.38-.42-.75-.73-1.13-.93,0,0-5.1-2.96-5.47-3.16l-.19-.11c-1.25-.59-2.4,.01-3.15,1.87-10.59,26.32-33.16,52.99-48.22,59.66-1.12,.5-2.16,1.27-2.96,2.21-1.06,1.23-1.72,2.74-1.67,4.31,0,33.84,18.54,87.91,53.66,105.98,2.08,1.36,4.23,2.59,6.44,3.67,48.32-49.84,54.62-129.68,54.62-169.78Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.92,184.57c-.63-.28-1.56-.01-2.68,.84-12.99,9.94-31.68,11.14-43.63,2.34,11.68,5.12,27.02,3.05,38.16-5.5,1.12-.85,2.05-1.12,2.68-.84l.08,.05s-.01,0-.01,.01c.59,.32,4.77,2.8,5.4,3.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.6,182.36c-1.25-.59-2.4,.01-3.15,1.87-10.59,26.33-33.16,52.99-48.22,59.66-1.12,.5-2.16,1.27-2.96,2.21-.44,.53-.82,1.09-1.11,1.7l-5.46-3.15c.28-.61,.65-1.19,1.09-1.7,.81-.94,1.85-1.71,2.96-2.21,15.05-6.67,37.62-33.34,48.22-59.66,.75-1.86,1.9-2.47,3.15-1.87l.19,.11c.18,.09,1.25,.71,2.43,1.39,1.16,.67,2.4,1.4,2.86,1.66Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.6,182.36c-1.25-.59-2.4,.01-3.15,1.87-10.59,26.33-33.16,52.99-48.22,59.66-1.12,.5-2.16,1.27-2.96,2.21-.44,.53-.82,1.09-1.11,1.7l-5.46-3.15c.28-.61,.65-1.19,1.09-1.7,.81-.94,1.85-1.71,2.96-2.21,15.05-6.67,37.62-33.34,48.22-59.66,.75-1.86,1.9-2.47,3.15-1.87l.19,.11c.18,.09,1.25,.71,2.43,1.39,1.16,.67,2.4,1.4,2.86,1.66Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.72,353.18c-35.08-18.08-53.59-72.12-53.59-105.93-.03-.92,.2-1.79,.58-2.61l5.46,3.15c-.39,.82-.59,1.7-.57,2.61,0,32.03,16.57,82.17,48.12,102.78Z",
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,187.12c0,40.1-6.3,119.95-54.62,169.78-35.76-17.55-54.63-72.34-54.63-106.49-.05-1.58,.61-3.09,1.67-4.31,.81-.94,1.85-1.71,2.96-2.21,15.05-6.67,37.62-33.34,48.22-59.66,.75-1.86,1.9-2.47,3.15-1.87h0l.19,.11c.38,.2,.75,.51,1.13,.93h.01c.07,.07,.13,.15,.2,.23,11.24,13.08,33.34,13.07,48.09,1.78,1.12-.85,2.05-1.12,2.68-.84l.08,.05s-.01,0-.01,.01c.59,.32,.92,1.15,.86,2.48Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,187.12c0,40.1-6.3,119.95-54.62,169.78-35.76-17.55-54.63-72.34-54.63-106.49-.05-1.58,.61-3.09,1.67-4.31,.81-.94,1.85-1.71,2.96-2.21,15.05-6.67,37.62-33.34,48.22-59.66,.75-1.86,1.9-2.47,3.15-1.87h0l.19,.11c.38,.2,.75,.51,1.13,.93h.01c.07,.07,.13,.15,.2,.23,11.24,13.08,33.34,13.07,48.09,1.78,1.12-.85,2.05-1.12,2.68-.84l.08,.05s-.01,0-.01,.01c.59,.32,.92,1.15,.86,2.48Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.61,182.36c-1.25-.59-2.4,.01-3.15,1.87-10.59,26.32-33.16,52.99-48.22,59.66-1.12,.5-2.16,1.27-2.96,2.21-1.06,1.23-1.72,2.74-1.67,4.31,0,34.15,18.87,88.94,54.63,106.49,24.03-92.9,1.38-174.54,1.38-174.54Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.61,182.36c-1.25-.59-2.4,.01-3.15,1.87-10.59,26.32-33.16,52.99-48.22,59.66-1.12,.5-2.16,1.27-2.96,2.21-1.06,1.23-1.72,2.74-1.67,4.31,0,34.15,18.87,88.94,54.63,106.49,24.03-92.9,1.38-174.54,1.38-174.54Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.84,200.41c12.06,3.08,22.75-2.21,28.86-5.36,0,0,1.42,70.77-22.95,116.54,9.61-35.75,11.97-45.98,12.66-72.48,.67-26.05-9.43-32.21-18.57-38.71Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "208.53 300.27 184.25 284.47 191.5 273.32 203.71 281.27 229.26 234.18 240.95 240.52 208.53 300.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.17,258.31l-12.46,22.96-12.21-7.95-7.25,11.14,24.28,15.81,7.24-13.35c.51-10.03,.6-19.61,.4-28.62Z",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character-2--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom-2--inject-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "341.75 402.39 338.02 400.61 341.69 399.57 341.75 402.39",
    style: {
      fill: "#3d200f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.88,409.41s43.79-19.87,44.36-16.95c.12,.64,.11,1.23-.01,1.76,.04-.05,.08-.1,.12-.16l-.77,5.46s-3.12,2.67-6.82,2.87c0-.26-.04-1.89-.06-2.81-1.19,.5-2.41,1.1-3.86,2.06-2.8,1.86-4.59,5.09-7.56,8.85-2.16,2.74-6.03,4.04-11.78,4.88-6.18,.91-11.65-.23-13.2-1.86-1.23-1.3-.64-3.71-.42-4.09Z",
    style: {
      fill: "#3d200f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.09,408.39c.42-.44,1.97-2.16,4.08-4.03,1.84-1.64,3.99-3.7,6.3-5.38,.92-.67,2.34-1.74,3.13-2.59,.76-.82,1.49-1.66,2.17-2.55,2.1-2.76,3.8-5.78,5.24-8.92,.68-1.49,1.53-3.06,1.82-4.68,.31-1.71,.48-3.44,.49-5.18,0-7.83-.18-9.07-.25-15.03l18.57,.48c-.59,3.31-1.48,7.82-1.78,11.58-.45,5.71-.6,6.98,1.7,12.66,.68,1.67,1.68,3.28,1.77,5.07,.16,2.92-2.15,5.46-4.73,6.9-2.14,1.2-4.62,1.72-6.7,3-2.19,1.34-3.88,3.35-5.43,5.34-1.47,1.88-2.64,4.09-4.7,5.42-2.29,1.47-4.48,1.94-7.14,2.49-3.06,.63-6.99,.73-9.61,.54-4.56-.32-7.97-1.94-4.92-5.14Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.17,399.34c-3.21-1.64-6.1-.94-6.82-.57-3.22,2.55-5.89,4.82-7.77,6.41-2.28,1.93-4.28,3.68-4.18,5.87,.16,3.43,13.66,4.37,21.17,1.07,3.92-1.38,5.3-4.64,5.3-4.64,0,0-1.15-4.79-7.7-8.14Zm25.56-12.5c-1.17-2.2-1.61-3.32-1.61-3.32-2.61,1.42-7.12,7.92-4.99,14.41,2.38-.63,4.7-1.55,6.58-4.48,1.42-2.22,1.19-4.41,.02-6.61Z",
    style: {
      fill: "#5c4a3a"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M382.86,389.39c-1.22,1.97,.32,9.35,.02,14.62-.27,4.78-1.57,13.12-.13,17.84,1.7,5.59,5.18,12.08,11.72,6.8,4.05-3.27,6.39-7.48,6.97-14.37,.4-4.79-1.46-11.4-3.06-17.26-1.87-6.85-2.57-10.51-2.57-10.51l-12.94,2.87Z",
    style: {
      fill: "#3d200f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.97,353.99c.48,11.16-.84,19-.92,26.15,.08,3.33,.3,6.14,1.04,9.65,.95,4.56,2.58,10.9,3.26,13.86,.95,4.13,1.67,6.73,.22,11.37-.11,.36-.28,.71-.48,1.05-2.03,3.82-7.19,6.7-8.85,6.24-.46,.75-1.63,1.21-2.91,1-.18-.03-.37-.07-.55-.13-.18-.06-.37-.13-.55-.22-1.1-.53-2.14-1.62-2.75-3.51-.1-.31-.19-.65-.27-1.01-1.2-5.75-.57-9.6-.54-11.86,.04-3.1-.03-6.1-.26-10.29-.23-4.19-.92-17-2.4-23.29-1.1-4.39-2.47-9.89-3.92-15.76l19.87-3.25Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.35,409.03c-4.07-1.76-15.88-2.01-17.76,3.63-.05,5.31-.08,8.91,3.34,13.53,4.54,6.14,10.46-.37,12.74-4.5,2.27-4.13,2.24-9.8,1.69-12.66Z",
    style: {
      fill: "#5c4a3a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.58,208.2c5.75,10.12,10.39,18.65,11.89,45.39,1.69,30.17,1.44,41.66,1.59,45.3,.15,3.64,2.54,10.32,4.57,28.25,2.03,17.93-.11,61.4-.11,61.4,0,0-1.44,2.93-8.42,3.59-6.44,.61-10.23-1.61-10.23-1.61,0,0-10.24-57.08-12.77-67.87-2.53-10.79-9.9-46.28-9.9-46.28l-2.42,33.87s2.04,9.89,.19,25.64c-1.85,15.75-6.6,45.52-6.6,45.52,0,0-2.74,2.72-11.16,2.56-8.96-.17-10.83-2.62-10.83-2.62,0,0-2.01-64.02-2.14-81.86-.13-17.84-1.19-64.15,4.33-90.6l52.01-.69Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.23,234.47c2.79,7.35,12.8,12.43,17.19,13.43l5.35,28.11v34.24l2.43-33.87-6.01-34.26s-12.16-.77-18.96-7.65Zm41.53-3.89c.74,2.89,1.41,5.8,2.13,8.7,.7,2.91,1.4,5.82,2.16,8.75,.05-3.03-.25-6.04-.67-9.02-.42-2.99-1.01-5.95-1.73-8.88-.75-2.92-1.61-5.83-2.69-8.66-1.08-2.83-2.34-5.61-4.01-8.16,.94,2.88,1.78,5.74,2.57,8.61,.78,2.88,1.54,5.76,2.25,8.66Zm5.12-5.61c1,1.74,1.95,3.5,2.91,5.26l2.84,5.38c-.19-2.05-.74-4.05-1.45-5.98-.7-1.94-1.61-3.79-2.6-5.58-1.03-1.78-2.15-3.51-3.42-5.13-1.26-1.63-2.63-3.17-4.19-4.55,.92,1.85,1.93,3.61,2.93,5.36,.99,1.76,2.01,3.49,2.98,5.24Zm-3.96,81.48c-1.82-9.23-3.14-18.56-4.44-27.9-1.27-9.34-2.53-18.7-3.92-28.04,.65,9.42,1.41,18.83,2.43,28.22,1,9.39,2.24,18.77,4.03,28.08,1.92,9.28,3.85,18.49,5.89,27.72,2.02,9.22,4.16,18.42,6.43,27.6-1.53-9.32-3.17-18.62-4.95-27.9-1.74-9.27-3.61-18.56-5.47-27.78Zm-41.98-30.5l1.39-24.61c-1.23,8.14-2.17,16.32-2.89,24.51-.69,8.21-1.34,16.38-1.31,24.7,.34,8.27,.57,41,1.61,49.16,.72-9.14,.49-33.25,.49-33.25-.24-4.09-.05-11.9-.16-15.96-.1-4.05,.12-8.16,.28-12.25,.16-4.1,.4-8.2,.6-12.3Z",
    style: {
      fill: "#5c4a3a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M296.82,71.93c9.44,2.53,18,11.3,22.42,20.24,19.62,.46,43.63,8.92,65.64,22.18l22.15-65.55c-36.83-9.8-73.58-6.31-110.2,23.13Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.62,134.02c-9.04-3.71-21.17-1.93-30.1,2.5-15.88-11.53-40.1-19.37-65.64-22.18l22.14-65.55c35.22,14.54,62.34,39.61,73.59,85.23Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.62,134.02c-9.04-3.71-21.17-1.93-30.1,2.5-15.88-11.53-40.1-19.37-65.64-22.18l22.14-65.55c35.22,14.54,62.34,39.61,73.59,85.23Z",
    style: {
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M319.24,92.17c19.61,.46,43.64,8.92,65.64,22.18l22.14-65.54c-25.69-3.21-63.54,12.73-87.78,43.37Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.24,92.17c19.61,.46,43.64,8.92,65.64,22.18l22.14-65.54c-25.69-3.21-63.54,12.73-87.78,43.37Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.62,134.02c-11.26-45.62-38.37-70.68-73.59-85.23,22.37,13.03,42.8,48.66,43.5,87.73,8.93-4.43,21.06-6.21,30.1-2.5Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.42,142.7c-1.34,1.42-1.76,2.91-3.92,2.22-1.85-.59-3.21-2.01-4.71-3.18-1.96-1.52-3.88-3.08-5.77-4.69-3.71-3.17-7.28-6.52-10.67-10.03-1.94-2.01-4.25-4.25-5.43-6.82-1.14-2.5-1.91-5.28-1.66-8.05,.52-5.7,4.05-13.11,14.53-15.23,8.73-1.77,25.41,.14,27.54,11.47,.11,.59,1.41,1.39,1.78,1.92,.65,.93,1.19,1.94,1.61,3,.85,2.11,1.23,4.41,1.07,6.68-.36,5.23-3.38,9.87-6.66,13.97-2.43,3.04-5.05,5.92-7.71,8.75Z",
    style: {
      fill: "#3d200f"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M321.21,163.63c-8.03,9.19-15.16,16.55-15.16,16.55,.02-.03-2.35-1.98-2.48-2.1-2.64-2.26-5.25-4.56-7.75-6.97-2.86-2.75-5.48-5.66-6.44-9.67-.21-.87-.3-1.77-.38-2.66-.25-2.57-.5-5.13-.74-7.7-.12-1.23-.42-2.57-.36-3.8,.04-.78,.45-1.72,.3-2.51-.17-.94-1.37-1.27-3.03,.32-1.03,.99-1.44,2.6-1.73,3.66-.33,1.17-.46,2.69-.87,2.76-.41,.07-1.77-1.33-3.28-2.28-1.52-.95-2.73-2.15-4.74-2.23-2.01-.07-2.49,1.66-2.46,2.35,.03,.72,.6,1.44,.6,1.44,0,0-.91-.48-1.94-.06-1.03,.43-1.63,2.26-1.13,3.18,0,0-1.16-.42-1.83,.78-.56,1.01-.81,2.13,.13,2.92,0,0-.96-.09-1.2,.41-.23,.5-.91,2.06-.22,2.97,.69,.91,2.84,1.78,2.84,1.78,0,0,.03,.44,.88,1.33,.3,.31,1.23,2.37,2.43,3.65,1.64,1.76,3.25,2.25,5.18,3.36,3.14,1.81,6.54,7.42,10.08,12.96,4.22,6.6,7.74,12.55,12.14,16.79,5.48,5.29,9.07,4.77,16.01-2.14,8.43-8.4,17.63-20,17.63-20l3.32-26.22c-6.27,.74-9.35,3.74-15.79,11.11Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.38,160.96c-.02,.18-.11,.29-.18,.44-.08,.18-.19,.33-.32,.48-.19,.21-.39,.42-.64,.56-.15,.09-.32,.14-.49,.19-.51,.14-1,.15-1.52,.15-.3,0-.59,.01-.89,.02,.38,.15,.77,.25,1.18,.3,.48,.05,1-.01,1.47-.13,.11-.03,.22-.06,.33-.11,.29-.13,.54-.34,.73-.6,.19-.26,.39-.63,.42-.96,0-.03,.02-.33-.02-.33,.34,.03,.66,0,.98-.03,.48-.08,1.02-.07,1.49-.43,.22-.19,.35-.39,.49-.63,.04-.07,.07-.16,.08-.24l.5-.37s-.15,1.2,.66,3.12c.81,1.92,2.39,3.07,2.39,3.07,0,0-1.17-1.01-1.81-3.5-.55-2.14,.54-4.58,1.46-5.7,.03,0,.06,0,.09,0,.22-.06,.37-.19,.49-.31,.27-.28,.38-.66,.39-1,0-.35-.06-.68-.17-.99-.43-1.26-1.43-2.17-2.49-2.84-.03-.3-.12-.56-.22-.81-.12-.27-.27-.52-.44-.76,.14,.26,.25,.53,.35,.8,.09,.27,.16,.56,.15,.83v.05l.04,.03c1,.73,1.9,1.67,2.26,2.83,.18,.55,.22,1.23-.15,1.59-.23,.21-.35,.25-.62,.11-.26-.12-.54-.3-.83-.44-.58-.3-1.17-.51-1.73-.78-.55-.27-1.06-.61-1.54-1.01-.47-.4-.9-.86-1.35-1.31-.44-.45-.88-.9-1.25-1.41,.65,1.09,1.49,2.05,2.39,2.95,.46,.44,.99,.84,1.57,1.12,.57,.29,1.17,.52,1.71,.81,.11,.06,.22,.12,.33,.18,.15,.26,.21,.55,.15,.83-.09,.51-.52,.86-1.02,.97-.52,.14-1.04,.27-1.55,.3-.52,0-1.08,.02-1.53-.15-.94-.36-1.72-1.19-2.56-1.86-.84-.69-1.68-1.38-2.56-2.02,.76,.79,1.54,1.53,2.34,2.28,.39,.37,.8,.73,1.22,1.09,.42,.35,.87,.71,1.43,.91,.35,.09,.69,.13,1.04,.14,.29,.21,.53,.47,.63,.79,.07,.21,.04,.43-.07,.61-.12,.18-.29,.39-.45,.5-.35,.22-.86,.25-1.33,.3-.48,.04-.97,.06-1.36-.1-.41-.15-.73-.51-1.15-.82-.41-.3-.85-.55-1.29-.76-.88-.45-1.77-.86-2.69-1.23,.84,.52,1.69,1.01,2.53,1.52,.41,.26,.84,.5,1.21,.79,.37,.28,.7,.69,1.22,.91,.17,.06,.33,.09,.5,.11Zm5.49-4.96s0-.02-.01-.03h0s0,.02,.01,.03Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.06,180.18c2.49,1.9,5.57,4.69,5.86,9.3,.74-5.21-2.14-9.29-4.7-10.79l-1.16,1.49Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M337.92,151.99c-8.03,.87-10.96,4.49-17.63,12.01-5.85,6.6-14.23,15.45-14.23,15.45l-12.18-10.29s.72,2.54-2.77,6.59c-2.91,3.37-7.11,2.67-7.11,2.67,0,0,4.85,8.19,11.12,17.43,6.35,9.37,11.47,10.3,15.98,7.83s25.46-24.69,25.46-24.69l1.36-26.99Z",
    style: {
      fill: "#5c4a3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.06,179.45c4.07,3.41,6.43,10.1,6.92,13.88,.69-8.71-5.03-15.88-5.03-15.88l-1.89,2Z",
    style: {
      fill: "#3d200f"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-39",
    d: "M386.27,222.01c3.36-2.73,.75-7.63-1.11-21.42-.57-4.25,2.16-14.78,2.16-14.78,0,0-7.88-11.88-5.33-32.51l-12.23-2.29-19.91-.3-11.45,1.92c-2.64,2.33-5.24,6.44-9.09,12.01-5.54,8.04-6.54,18.89-.56,25.29,.09,1.26,.27,9.86-.27,14.83-.75,6.89-4.59,13.59-.59,16.99,11.69,9.93,42.51,10.62,58.37,.25Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest-2--inject-39",
    d: "M386.27,222.01c3.36-2.73,.75-7.63-1.11-21.42-.57-4.25,2.16-14.78,2.16-14.78,0,0-7.88-11.88-5.33-32.51l-12.23-2.29-19.91-.3-11.45,1.92c-2.64,2.33-5.24,6.44-9.09,12.01-5.54,8.04-6.54,18.89-.56,25.29,.09,1.26,.27,9.86-.27,14.83-.75,6.89-4.59,13.59-.59,16.99,11.69,9.93,42.51,10.62,58.37,.25Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head-2--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head-3--inject-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M372.2,136.16c2.3,.42,4.48-.69,5.87-2.19,3.1-3.34,3.39-6.74,1.95-9.01-1.18-1.86-4.1-3.05-6.15-1.8-2.19,1.34-2.26,2.44-3.09,3.97-.85,1.56-2.95,.33-2.23-5.78-1.25-.58-2.1-1.65-2.7-2.86-.14-.28-1.26-3.72-1.23-3.71-2.56-.52-4.86-2.18-6.16-4.44-.05,1.12,.2,2.26,.72,3.26-1.83-.11-3.69-.23-5.44-.77s-3.43-1.55-4.42-3.09c-.13,1.7,.14,3.43,.78,5.01-3.91-.68-7.19-4.1-7.71-8.04-1.49,2.41-3.07,4.59-3.75,7.37-.65,2.69-.98,5.46-1.24,8.21-1.03,11.07-.06,16.77,3.26,19.78,1.79,1.62,4.73,3.37,9.34,3.52l-.15,5.15s-11.33,10.76,3.28,9.7c10.95-.79,16.56-9.21,16.56-9.21l.1-16.79s.24,1.34,2.42,1.74Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M348.21,134.19c.35,1.73,2.07,2.86,3.83,2.52,1.77-.34,2.91-2.03,2.56-3.76l-6.4,1.25Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.63,133.99c-.18,1.32-1.18,2.44-2.58,2.72-.39,.08-.78,.07-1.15,.01,.27-1.76,1.94-2.98,3.74-2.73Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M355.51,116.85l4.2,2.2c.67-1.13,.27-2.53-.89-3.14-1.16-.61-2.64-.19-3.31,.94Z",
    style: {
      fill: "#3d200f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.15,116.36l-4.2,2.2c-.67-1.13-.27-2.53,.89-3.14,1.16-.61,2.64-.19,3.31,.94Z",
    style: {
      fill: "#3d200f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.85,122.03c0,.96-.78,1.73-1.73,1.73s-1.73-.78-1.73-1.73,.78-1.73,1.73-1.73,1.73,.78,1.73,1.73Z",
    style: {
      fill: "#3d200f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.5,121.5c0,.96-.78,1.73-1.73,1.73s-1.73-.78-1.73-1.73,.78-1.73,1.73-1.73,1.73,.78,1.73,1.73Z",
    style: {
      fill: "#3d200f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.36 126.75 349.27 129.86 351.18 117.85 343.36 126.75",
    style: {
      fill: "#f0997a"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M350,145.57c5.72-.21,14.76-2.61,17.37-8.9-1.53,6.66-7.11,9-10.32,9.89-3.91,1.08-7.01,1.19-7.01,1.19l-.04-2.17Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M349.82,149.28l.03,1.44s-8.07,6.05-14.04,15.89c-5.97,9.84-4.17,22.16-4.47,34.85-.3,12.69,.37,39.61,.37,39.61,0,0-5.63-1.14-8.51-5.45,0-7.07,2.01-31.17,2.14-38.72,.11-6.1-.28-9.16-1.27-14.75-.99-5.59-.12-16.69,13.85-30.15l11.9-2.72Z",
    style: {
      fill: "#3d200f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.69,149.63s-5.43,12.13-5.61,24.5c-.18,12.36,4.89,72.39,4.89,72.39,0,0,18.91,1.51,27.94-6.44-1.98-9.74-6.44-23.98-8.03-30.11-1.59-6.14-2.47-11.12-1-17.52,1.47-6.39,2.78-10.59,2.78-10.59l-7.25-29.12-13.72-3.1Z",
    style: {
      fill: "#3d200f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm-2--inject-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M402.81,61.3l.49,.08c.15,.02,.35,.05,.57,.09,.16,.01,.37,.03,.5,.02,.75,.03,.57-.36,.75-.72,.25-.75,.6-1.83,1.02-3.12,.83-2.58,1.88-6.05,2.82-9.55,.48-1.75,.92-3.51,1.3-5.17,.19-.83,.4-1.63,.55-2.39,.16-.77,.31-1.49,.46-2.16,.15-.67,.25-1.29,.35-1.84,.1-.55,.19-1.03,.25-1.42,.13-.79,.19-1.25,.19-1.25,0,0-.23,.4-.6,1.11-.19,.35-.42,.78-.66,1.28-.25,.5-.55,1.05-.83,1.67-.29,.62-.61,1.29-.95,1.99-.34,.7-.66,1.46-1.01,2.24-.7,1.55-1.42,3.22-2.1,4.9-1.37,3.36-2.64,6.75-3.55,9.31-.45,1.28-.82,2.35-1.08,3.1-.07,.39-.45,.59,.17,1.03,.1,.09,.28,.2,.41,.29,.2,.11,.37,.2,.51,.28,.28,.15,.43,.23,.43,.23Z",
    style: {
      fill: "#3d200f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.8,183.18l38.35-113.96c.3-.88,1.25-1.35,2.13-1.05,.88,.3,1.35,1.25,1.05,2.13l-38.35,113.96c-.89,.62-3.01-.14-3.18-1.07Z",
    style: {
      fill: "#e5d4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.47,182.67l-4.55,11.73c-2.41,6.58-6.36,7.37-10.12,5.91-3.9-1.51-3.57-7.72-2.58-10.24,.99-2.52-2.91-5.23-4.83-1.85-1.92,3.38-3.76,13.73,5.59,17.39,5.31,2.08,10.72,.08,13.48-2.42,1.25-1.14,2.42-2.4,3.58-5.37l5.03-12.99-5.61-2.17Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.63,181.93c1.33-.27,3.14,.33,4.04,1.34,.9,1.01,.56,2.06-.77,2.33-1.33,.27-3.14-.33-4.04-1.34-.9-1.01-.56-2.06,.77-2.33Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M394.74,85.15c20.48,3.12,38.53,11.69,54.15,25.71,16.63,4.18,26.48,12.33,31.72,23.16-9.63-46.27-39.58-73.73-73.59-85.23-34.02-11.49-74.49-7.82-110.2,23.13,10.74-5.43,23.51-5.94,39.27,.82,20.92-1.68,40.48,2.46,58.65,12.4Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.74,85.15c20.48,3.12,38.53,11.69,54.15,25.71,16.63,4.18,26.48,12.33,31.72,23.16-9.63-46.27-39.58-73.73-73.59-85.23-34.02-11.49-74.49-7.82-110.2,23.13,10.74-5.43,23.51-5.94,39.27,.82,20.92-1.68,40.48,2.46,58.65,12.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M336.09,72.75c20.93-1.68,40.48,2.46,58.65,12.4l12.28-36.35c-38.86-13.13-70.94,23.95-70.94,23.95Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.09,72.75c20.93-1.68,40.48,2.46,58.65,12.4l12.28-36.35c-38.86-13.13-70.94,23.95-70.94,23.95Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.9,110.86c-15.62-14.03-33.68-22.59-54.16-25.71l12.28-36.35c38.86,13.13,41.88,62.06,41.88,62.06Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.62,134.02c-9.63-46.27-39.58-73.73-73.59-85.23,38.86,13.13,41.87,62.07,41.87,62.07,16.63,4.18,26.48,12.33,31.72,23.16Z",
    style: {
      fill: "#e9a026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.62,134.02c-9.63-46.27-39.58-73.73-73.59-85.23,38.86,13.13,41.87,62.07,41.87,62.07,16.63,4.18,26.48,12.33,31.72,23.16Z",
    style: {
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M411.15,213.82c-9.94,1.57-26.96-4.11-38.79-5.04-3.16-.24-5.86,.04-6.99,.06-4.26,.06-6.53-3.84-9.39-6.13-.15-.11-.29-.22-.44-.33-.61-.44-1.28-.82-2.02-1.1-1.75-.93-2.2-1.14-2.72-1.86-2.12,1.82-4.28,1.62-5.53,1.34-.76-1.17-1.26-2.43-.89-3.14,.27-.5,.71-.65,.71-.65,0,0-.16-.27-.32-1.65-.26-2.08,1.63-2.5,2.84-2.96,0,0-.37-1.16,.48-2.03,.84-.87,1.79-1.51,6.34-3.37,.68-.28,1.35-.6,2.27-.59,.11,0,.21,0,.33,.01,.89,.05,2.02,.39,3.6,1.28,.42,.24,.99,.58,1.65,.98,.08,.05,.17,.1,.26,.15,3.4,2.03,9.22,5.07,11.4,5.79,2.67,.88,20.62-.64,20.62-.64l-8.01-16.48s-6.35-13.81-3.36-23.34c7.79,.07,11.91,1.13,17.05,7.41,5.12,6.25,16.76,34.96,17.88,40.09,1.25,5.76,2.74,10.66-6.97,12.2Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.67,192.09l.89,1.86c4.6,.03,11.06,4.39,12.67,6.46-1.71-3.49-5.44-8.19-13.56-8.32Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M347.61,192.36l5.34-2.49-5.41,1.7c-.02,.28,0,.54,.07,.79Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.09,196.97l6.25-2.41-6.44,1.67c.03,.24,.1,.48,.19,.73Z",
    style: {
      fill: "#f0997a"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M383.42,152.74c7.71,.22,14.33,2.16,19.6,11.32,5.26,9.16,9.87,20.4,13.38,30.32,3.51,9.92,4.27,14.79,1.42,17.39-2.85,2.6-7.82,3.59-15.9,2.69-8.08-.9-20.05-3.95-20.05-3.95,0,0,2.04-3.57,1.71-9.14-.33-5.57-1.87-6.67-1.87-6.67l12.03-1.04s-4.7-9.56-7.88-16.17c-3.18-6.62-5.34-21.11-2.45-24.75Z",
    style: {
      fill: "#5c4a3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.75,193.66c5.05-.38,11.32,1.01,14.19,4.81-2.88-6.66-11.65-7.34-15.24-6.97l1.06,2.15Z",
    style: {
      fill: "#3d200f"
    }
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech_Bubble--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech_Bubble-2--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech_Bubble-3--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.14,123.95l-4.59-6.58c5.11-11.28,1.5-24.97-9.11-32.11-11.83-7.96-27.93-4.81-35.89,7.01-7.95,11.83-4.81,27.92,7.02,35.88,10.61,7.14,24.65,5.33,33.17-3.65l7.84,1.77c1.34,.3,2.35-1.2,1.56-2.32Zm-8.37-3.94c-3.28,4.88-8.06,8.14-13.32,9.62l-2.66,.59c-5.77,.93-11.88-.23-17.1-3.74-10.9-7.34-13.8-22.18-6.46-33.08,3.51-5.22,8.74-8.59,14.43-9.9l2.69-.46c5.42-.62,11.08,.61,15.96,3.9,10.9,7.34,13.8,22.17,6.47,33.07Z",
    style: {
      fill: "#4a3729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,86.94c-4.88-3.29-10.54-4.51-15.96-3.9l-2.69,.46c-5.69,1.31-10.92,4.69-14.43,9.9-7.34,10.9-4.44,25.74,6.46,33.08,5.22,3.51,11.33,4.66,17.1,3.74l2.66-.59c5.26-1.47,10.04-4.74,13.32-9.62,7.34-10.9,4.43-25.74-6.47-33.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.06,118.93c-.91,0-1.78-.38-2.41-1.04l-7.47-7.98c-1.24-1.33-1.18-3.42,.15-4.66,1.33-1.25,3.42-1.18,4.66,.15l4.85,5.18,11.49-14.55c1.13-1.43,3.2-1.67,4.63-.55,1.43,1.13,1.67,3.2,.55,4.63l-13.86,17.56c-.59,.75-1.49,1.21-2.45,1.25-.05,0-.09,0-.14,0Z",
    style: {
      fill: "#e9a026"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceAmico);
export default __webpack_public_path__ + "static/media/Insurance-amico.ef41d798188eaefec4b0e2d26073f382.svg";
export { ForwardRef as ReactComponent };